import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { formatDateTime } from '@ifeng-fe/container_channel/common/client/spring/mobile/utils/utils';
import { handleTime } from '@ifeng-fe/container_channel/common/client/spring/mobile/utils/timeUnit';
import share_btn from './share_btn.png';
import ShareImg from '@src/mobile/studio/layout/shareimg';

class AllNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        moreData: PropTypes.func,
    };

    constructor(props) {
        super(props);

        const arrLen = props.content.map(item => {
            return item.brief.length > 60;
        });

        this.state = {
            newsLen: 20,
            show: false,
            curTime: '',
            title: '',
            numLen: arrLen,
            shareTime: '',
            shareTitle: '',
            shareBref: '',
            sharePic: '',
            shareUrl: '',
            isCompleteShare: false,
        };
    }

    box = React.createRef();

    addMore = index => {
        const curLen = this.state.numLen;

        if (curLen[index]) {
            curLen[index] = !curLen[index];
            this.setState({
                numLen: [...curLen],
            });
        }
    };
    // 点击跳转
    handleClick = (id, url, type) => {
        let _type = '';
        const _id = id;

        if (type) {
            _type = 'doc';
            if (type === 'web' || !id) {
                _type = 'web';
            }
            if (type?.toLocaleLowerCase?.()?.indexOf?.('video') > -1 && id) {
                _type = 'phvideo';
            }
        } else {
            _type = 'doc';
            if (!id) {
                _type = 'web';
            }
        }

        // 文章是否发布
        if (url) {
            if (window.grounds) {
                window.grounds.dispatch(_type, _type === 'web' ? url : `ucms_${_id}`);
            } else {
                window.location.href = url;
            }
        }
    };
    getShare = item => {
        const { title, _brief, url, sharePosterUrl, ctime } = item;

        if (window.grounds) {
            this.setState({
                shareTime: parseInt(ctime) * 1000,
                shareTitle: title,
                shareBref: _brief,
                sharePic: sharePosterUrl,
                shareUrl: url,
                isCompleteShare: false,
            });
        }
    };

    getMore = () => {
        const arrLen = this.props.content.map(item => {
            return item.brief.length > 80;
        });

        this.setState({
            newsLen: this.state.newsLen + 10,
            numLen: arrLen,
        });
    };

    componentDidMount() {
        const documentWidth = document.documentElement.clientWidth;
        const onPullUpTop = this.box.current.offsetTop + (documentWidth * 180) / 750;

        window.addEventListener('scroll', () => {
            this.handleScroll(onPullUpTop);
        });
    }

    handleScroll = onPullUpTop => {
        const onPullUpHeight = this.box.current.clientHeight;
        const documentHeight = document.documentElement.clientHeight;
        const documentTop = document.body.scrollTop || document.documentElement.scrollTop;

        if (onPullUpHeight > documentHeight && onPullUpHeight <= documentHeight + documentTop - onPullUpTop + 100) {
            this.props.moreData();
            setTimeout(this.getMore, 300);
        }
    };

    handleStrLength = str => {
        let nameLength = 0;

        for (let i = 0; i < str.length; i++) {
            const a = str.charAt(i);

            /* eslint-disable */
            if (a.match(/[^\x00-\xff]/gi) != null) {
                nameLength += 2;
            } else {
                nameLength += 1;
            }
        }

        return nameLength;
    };

    handleCompleteShare = () => {
        this.setState({
            isCompleteShare: true,
        });
    };

    render() {
        const { content } = this.props;
        const { newsLen, numLen, shareTime, shareTitle, shareBref, sharePic, shareUrl, isCompleteShare } = this.state;
        const curDate = new Date().getTime();
        const prevDate = curDate - 24 * 60 * 60 * 1000 * 2;

        let oldTime = '';

        const newArr = content.filter(item => {
            const newDate = Number(item.ctime) * 1000;

            if (newDate >= prevDate && newDate <= curDate) {
                return item;
            } else {
                return false;
            }
        });

        return (
            <div className={styles.all_list} ref={this.box}>
                {newArr.map((item, index) => {
                    const curTime = formatDateTime(Number(item.ctime) * 1000);
                    item.newsTime = curTime;
                    const nowTime = curTime.slice(0, 10);
                    const brief = item.brief.replace(/\n\n/g, '<br /><br />').replace(/\n/g, '<br /><br />');
                    const url = item.url;
                    const id = item.ucmsid;

                    if (nowTime !== oldTime) {
                        oldTime = nowTime;

                        return (
                            <React.Fragment key={index}>
                                <div className={styles.new_date} data-groupdate={nowTime}>
                                    <span>{`${nowTime.slice(0, 4)}年${nowTime.slice(5, 7)}月${nowTime.slice(
                                        8,
                                    )}日`}</span>
                                </div>
                                <div className={styles.new_box} key={index} data-newsdate={curTime}>
                                    <div className={styles.new_box_bor}>
                                        <div className={styles.new_time}>{handleTime(curTime)}</div>
                                        <div
                                            className={`${styles.new_txt} ${
                                                numLen[index] ? '' : styles.leaveMaxHeight
                                            }`}
                                            onClick={() => {
                                                this.handleClick(id, url, item.type);
                                            }}>
                                            <div dangerouslySetInnerHTML={{ __html: brief }} />
                                            {brief && this.handleStrLength(brief) > 160 && numLen[index] ? (
                                                <div
                                                    className={styles.more}
                                                    onClick={e => {
                                                        e.stopPropagation(e);
                                                        this.addMore(index);
                                                    }}>
                                                    展开
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                        {window.grounds &&
                                            url && (
                                                <div className={styles.share_btn} onClick={() => this.getShare(item)}>
                                                    <img src={share_btn} alt="" />
                                                </div>
                                            )}
                                    </div>
                                </div>
                            </React.Fragment>
                        );
                    } else {
                        return (
                            <div className={styles.new_box} key={index} data-newsdate={curTime}>
                                <div className={styles.new_box_bor}>
                                    <div className={styles.new_time}>{handleTime(curTime)}</div>
                                    <div
                                        className={`${styles.new_txt} ${numLen[index] ? '' : styles.leaveMaxHeight}`}
                                        onClick={() => {
                                            this.handleClick(id, url, item.type);
                                        }}>
                                        <div dangerouslySetInnerHTML={{ __html: brief }} />
                                        {brief && this.handleStrLength(brief) > 160 && numLen[index] ? (
                                            <div
                                                className={styles.more}
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    this.addMore(index);
                                                }}>
                                                展开
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                    {window.grounds &&
                                        url && (
                                            <div className={styles.share_btn} onClick={() => this.getShare(item)}>
                                                <img src={share_btn} alt="" />
                                            </div>
                                        )}
                                </div>
                            </div>
                        );
                    }
                })}
                {!isCompleteShare &&
                    shareTime && (
                        <ShareImg
                            curTime={shareTime}
                            title={shareTitle}
                            bref={shareBref}
                            url={shareUrl}
                            img={sharePic}
                            handleCompleteShare={this.handleCompleteShare}
                        />
                    )}
            </div>
        );
    }
}

export default errorBoundary(AllNews);
